<template>
  <div>
    <div class="report-message">
      <div
        v-if="isNewReport"
        class="icon"
        @click="$emit('click')"
      >
        <div class="icon-background new-report-icon">
          <AddReportIcon
            :color="newReportColor"/>
        </div>
      </div>
      <div
        v-else-if="isAlert"
        class="icon"
      >
        <div class="icon-background alert-icon">
          <AlertIcon
            :color="alertColor"/>
        </div>
      </div>
      <div
        v-else-if="noResults"
        class="icon"
        @click="$emit('click')"
      >
        <div class="icon-background no-result-icon">
          <SearchIcon
            :color="noResultColor"/>
        </div>
      </div>
      <div
        v-else
        class="icon"
      >
        <div class="icon-background lock-icon">
          <LockIcon
            :color="lockColor"/>
        </div>
      </div>
      <h1 class="heading">
        {{ title }}
      </h1>
      <div
        v-if="description"
        class="description"
      >
        <div
          v-for="(line, index) in description"
          :key="'new-report-desc-'+index"
        >
          {{ line }}
        </div>
      </div>
      <div
        v-if="tip"
        class="tip"
      >
        {{ tip }}
      </div>
      <SecondaryButton
        v-if="showButton"
        @click="actionFunction"
      >
        {{ actionLabel }}
      </SecondaryButton>
    </div>
  </div>
</template>

<script>
import {
  AddReportIcon,
  SearchIcon,
  LockIcon,
  SecondaryButton,
} from '@mikmak/components';
import AlertIcon from './Icons/AlertIcon';

export default {
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {
      newReportColor: '#ffffff',
      alertColor: '#000000',
      noResultColor: '#ffffff',
      lockColor: '#ffffff',
    };
  },
  computed: {
    title() {
      return this.message.title;
    },
    description() {
      return this.message.description;
    },
    tip() {
      return this.message.tip;
    },
    actionLabel() {
      return this.message.action && this.message.action.label ?
        this.message.action.label : '';
    },
    actionFunction() {
      return this.message.action && this.message.action.function ?
        this.message.action.function : null;
    },
    showButton() {
      return !!(this.actionFunction && this.actionLabel);
    },
    isAlert() {
      return this.message.isAlert;
    },
    noResults() {
      return this.message.noResults;
    },
    isNewReport() {
      return this.message.isNewReport;
    },
  },
  components: {
    AddReportIcon,
    AlertIcon,
    SearchIcon,
    LockIcon,
    SecondaryButton,
  },
};
</script>

<style scoped>
.report-message {
  height: auto;
  margin: auto;
  width: 725px;
  line-height: 140%;
  font-size: 16px;
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  text-align: center;
  color: #778699;
}
.icon-background {
  width: 40px;
  margin: auto;
  height: 40px;
  border-radius: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.new-report-icon,
.no-result-icon{
  background: #4369F4;
}
.alert-icon{
  background: #FEB631;
}
.lock-icon {
  background-color: #4369F4;
}
.heading {
  font-size: 24px;
  font-weight: 400;
  color: #223448;
  padding: 8px;
}
.content {
  height: 448px;
  display: flex;
  flex-direction: column;
}
.inactive-report {
  height: 504px;
  display: flex;
  flex-direction: column;
}
.tip {
  padding: 24px;
  font-style: italic;
}
</style>
